import {sortObjKeys} from '@/utilities/';

export const isObjectsEqual = (first: object, second: object): boolean => {
  return JSON.stringify(sortObjKeys(first)) === JSON.stringify(sortObjKeys(second));
};
